import clsx from 'clsx'
import React from 'react'

import {classes} from './UnstableCardFooter.classes'

type Props = {
  className?: string
  enableNegativeMargin?: boolean
}

export const UnstableCardFooter: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  enableNegativeMargin = true,
  children,
}) => {
  return (
    <>
      <div className={classes.min_margin} />
      <div className={clsx(classes.root, {[classes.negative_margin]: enableNegativeMargin}, className)}>{children}</div>
    </>
  )
}
